import React, { useEffect, useRef } from "react";
import { useTheme, ITheme } from "src/theme";
import { styled } from "@linaria/react";
import { css } from "@linaria/core";
import close from "@assets/icon/close.svg";
import closeWhite from "@assets/icon/close-white.svg";

const ModalContainer = styled.div<StyledProps>`
  position: fixed;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0 auto;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 105;
  overflow-x: hidden;
  background-color: rgba(51, 51, 51, 0.85);
  pointer-events: none;
  opacity: 0;
  transition: opacity 500ms ease;
  box-shadow: none;
`;

const ModalContent = styled.div<StyledProps>`
  overflow-x: hidden;
  position: relative;
  width: 100%;
  max-width: 690px;
  max-height: 620px;
  min-height: 180px;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 20px;
  border-radius: 4px;
  padding: 30px 20px;
  align-self: center;
  box-shadow: none;
  opacity: 0;
  transition: opacity 300ms ease, transform 300ms 250ms ease;
  // transform: scale(0);
  display: flex;
`;
const Body = styled.div<StyledProps>`
  background-color: ${(props) => props.theme?.colors.white + ""};
  width: 100%;
  margin: 0;
  padding: 40px 24px;
  overflow-y: auto;
  border-radius: 16px;
  @media screen and (min-width: 768px) {
    padding: 36px 51px;
  }
`;
const visable = css`
  pointer-events: auto;
  opacity: 1;
  transition: all 300ms ease-in-out;
`;

const visableContent = css`
  opacity: 1;
  // transform: scale(1);
  transition: opacity 300ms ease, transform 500ms 500ms ease;
`;

const CloseIcon = styled.img`
  cursor: pointer;
  width: 18px;
  height: 18px;
  transform: rotate(90deg);
  transition: all 0.8s ease-out 0s;

  &:hover {
    transform: rotate(360deg);
    transition: all 1s ease-out 0s;
  }
`;

const CloseButton = styled.div<
  StyledProps & { isErrorModal: boolean | undefined }
>`
  position: absolute;
  background-color: ${(prop) => prop.closeBtnColor || "#CA9AC7"};
  top: 10px;
  right: 5px;
  width: 36px;
  height: 36px;
  border-radius: 100%;
  display: ${(props) => (props.isErrorModal ? "none" : "flex")};
  align-items: center;
  justify-content: center;

  /* &:before, &:after {
  position: absolute;
  content: ' ';
  height: 24px;
  width: 2px;
  background-color: #fff;
}

&:before {
  transform: rotate(45deg);
}
&:after {
  transform: rotate(-45deg);
} */
`;

interface StyledProps {
  theme?: ITheme;
  closeBtnColor?: string;
}

export interface ModalProps {
  children?: React.ReactNode;
  showClose?: () => void;
  show: boolean;
  onClose?: React.MouseEventHandler<HTMLDivElement>;
  theme?: ITheme;
  className?: string | undefined;
  isErrorModal?: boolean;
  colseBtnColor?: string;
}

function Modal({
  children,
  show,
  onClose,
  className,
  isErrorModal,
  colseBtnColor,
}: ModalProps) {
  const modalRef = useRef<HTMLDivElement>(null);
  const contentModalRef = useRef<HTMLDivElement>(null);
  const theme = useTheme();
  const modalCancel = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const { id } = e.target as HTMLDivElement;
    if (id === "modal") {
      onClose && onClose(e);
    }
  };
  const closeImg =
    window.location.hash.includes("evergreen") ||
    window.location.hash.includes("ccp")
      ? closeWhite
      : close;
  useEffect(() => {
    if (!modalRef.current || !contentModalRef.current) {
      return;
    }
    if (show) {
      modalRef?.current.classList.add(visable);
      contentModalRef.current.classList.add(visableContent);
    } else {
      modalRef.current.classList.remove(visable);
      contentModalRef.current.classList.remove(visableContent);
    }
  }, [show]);
  return (
    <ModalContainer
      onClick={modalCancel}
      id="modal"
      ref={modalRef}
      theme={theme}
      className={className}
    >
      <ModalContent ref={contentModalRef} className="modal-content">
        {onClose && (
          <CloseButton
            onClick={onClose}
            closeBtnColor={colseBtnColor}
            isErrorModal={isErrorModal}
          >
            <CloseIcon src={closeImg} />
          </CloseButton>
        )}
        <Body theme={theme} className="modal-body">
          {children}
        </Body>
      </ModalContent>
    </ModalContainer>
  );
}

Modal.defaultProps = {
  show: false,
  // onClose: () => {},
};

export default Modal;
